import _ from "lodash";
import update from "immutability-helper";

export const NAME = "LEIntoUnitImport";

//redux
export const UPDATE_GRADE_ID = "UPDATE_GRADE_ID " + NAME;
export const UPDATE_FILTER = "UPDATE_FILTER " + NAME;
export const UPDATE_SELECTED_UNIT = "UPDATE_SELECTED_UNIT" + " " + NAME;
export const UPDATE_CURRICULUM_TYPE = "UPDATE_CURRICULUM_TYPE" + " " + NAME;
export const RESET_STATE = "RESET_STATE" + " " + NAME;

export const updateGradeId = payload => ({
  type: UPDATE_GRADE_ID,
  payload,
});

export const updateFilters = payload => ({
  type: UPDATE_FILTER,
  payload,
});

export const updateSelectedUnit = payload => ({
  type: UPDATE_SELECTED_UNIT,
  payload,
});

export const updateCurriculumType = payload => ({
  type: UPDATE_CURRICULUM_TYPE,
  payload,
});

export const resetState = payload => ({
  type: RESET_STATE,
  payload,
});

const initialState = {
  gradeId: "",
  selectedUnit: {},
  curriculumType: "",
  filters: {
    searchText: "",
    subjects: [],
    creators: [],
    courses: [],
    unitTypes: [],
  },
};

const REDUCER_HANDLERS = {
  [UPDATE_GRADE_ID]: (state, action) => {
    const id = action.payload;
    return update(state, {
      gradeId: { $set: id },
    });
  },
  [UPDATE_FILTER]: (state, action) => {
    const params = action.payload;
    _.forEach(params, (value, key) => {
      state = update(state, {
        filters: {
          [key]: { $set: value },
        },
      });
    });
    return state;
  },
  [UPDATE_SELECTED_UNIT]: (state, action) => {
    const selectedUnit = action.payload;
    return update(state, {
      selectedUnit: { $set: selectedUnit },
    });
  },
  [UPDATE_CURRICULUM_TYPE]: (state, action) => {
    const type = action.payload;
    return update(state, {
      curriculumType: { $set: type },
    });
  },
  [RESET_STATE]: (state, action) => {
    return initialState;
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
